import React from "react";

function ReservationGridItems(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ReservationGridItems;
